import type { SubPage, Tab } from '../context/tab-manager-context';

import { ViewType } from '@controlrooms/models';

export const SUBPAGE_NAMES: Record<SubPage, string> = {
  monitors: 'Manage Monitors',
  formulas: 'Manage Formulas',
  inheritance: 'Manage Inheritance',
  alerts: 'Manage Alerts',
  user_groups: 'Manage Users & Groups',
  webhooks: 'Manage Webhooks',
};

/** When tab.name is empty, derive display label from tabType, viewType, subPage, isTrendSearch */
export function getTabDisplayName(tab: Tab): string {
  if (tab.name?.trim()) return tab.name;
  if (tab.type === 'VIEWS') {
    const viewType = tab.viewType ?? ViewType.MONITOR;
    if (viewType === ViewType.ANALYZE && tab.isTrendSearch) return 'Trend Search';
    if (viewType === ViewType.ANALYZE) return 'Assess';
    if (viewType === ViewType.INVESTIGATE) return 'Investigate';
    return 'Monitor';
  }
  if (tab.type === 'MANAGE') return SUBPAGE_NAMES[tab.subPage ?? 'monitors'];
  if (tab.type === 'ALERT_BOARD') return 'Alert Board';
  if (tab.type === 'ALERT_MANAGER') return 'Alert Manager';
  if (tab.type === 'LIMIT_MANAGER') return 'Limit Manager';
  return 'Tab';
}
